import { MODAL_UPGRADE_PLAN } from '@components/App/Modal/constants'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

// Opens the upgrade modal from the AI chat (action-limit, paywall, agent
// "upgrade" suggestion) and reports the GTM event — one flow for all entry
// points.
export const useOpenUpgradeModal = (): (() => void) => {
  const dispatch = useDispatch()

  return () => {
    sendGtmEvent(GtmTriggerName.AI_CHAT_UPGRADE)
    dispatch(
      openModal({
        modalType: MODAL_UPGRADE_PLAN,
        modalProps: {
          planType: 'pro',
        },
      })
    )
  }
}
